<template>
  <span>
    <span @click="showModal">
      <slot></slot>
    </span>
    <b-modal v-model="modalView" size="lg" centered no-fade>
      <div slot="modal-header">{{$t('TEAM.ADD.TITLE')}}</div>
      <div class="p-4 text-center" v-if="modalLoading">
        <img src="/img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('TEAM.ADD.PROCESSING')}}</h5>
      </div>
      <div class="pl-4 pr-4" v-if="modalLoading === false">
        <form enctype="multipart/form-data">
          <div class="form-group row">
            <label class="col-form-label">{{ $t('TEAM.ADD.INPUT_EMAIL') }}</label>
            <b-input
              v-on:keyup.enter="modalSubmit"
              v-model="addEmail"
              type="text"
              name="name"
              required
              autofocus
            ></b-input>
          </div>

          <div class="form-group row">
            <b-form-group :label="$t('TEAM.ADD.INPUT_ADMIN')">
              <b-form-radio-group id="addAdmin" v-model="addAdmin" name="publish">
                <b-form-radio value="0">{{ $t('NO')}}</b-form-radio>
                <b-form-radio value="1">{{ $t('YES')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <div v-if="modalLoading === false">
          <b-btn @click="hideModal">{{ $t('CLOSE')}}</b-btn>
          <b-button
            :disabled="!validEmail"
            variant="primary"
            class="btn-fill"
            @click="modalSubmit"
          >{{ $t('TEAM.ADD.SUBMIT')}}</b-button>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<script>
export default {
  data() {
    return {
      modalView: false,
      modalLoading: false,
      addEmail: "",
      addAdmin: 0,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,      
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    showModal() {
      this.modalView = true;
    },
    hideModal() {
      this.modalView = false;
      this.addEmail = "";
      this.addAdmin = 0;
      this.modalLoading = false;
    },
    modalSubmit: function() {
      let self = this;
      if (this.validEmail === false) {
        this.$noty.error(this.$t("TEAM.ADD.ERROR.NOT_VALID_MAIL"));
        return false;
      }
      this.modalLoading = true;
      this.$http
        .post(process.env.VUE_APP_BACKEND + `/invite/add`, {
          email: this.addEmail,
          admin: parseInt(this.addAdmin)
        })
        .then(function() {
          self.hideModal();
          self.$emit("invitedResult");
          self.$noty.info(self.$t("TEAM.ADD.SUCCESS.ADDED_USER"));
        })
        .catch(function(error) {
          self.modalLoading = false;
          self.$noty.error(self.$t(error.response.data));
        });
    }
  },
  computed: {
    validEmail: function() {
      if(this.addEmail == "")
      {
        return false;
      }else{
        return this.reg.test(this.addEmail);
      }      
    }
  }
};
</script>
<style>
</style>